(function () {
  'use strict';

  var CUSTOMER_ID = window.__CUSTOMER_ID__ || 'guest';
  var STORAGE_KEY = 'customColorsByVariantName_' + CUSTOMER_ID;
  var syncQueue = Promise.resolve();

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function readMap() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function isCustomColorLine(item) {
    if (!item) return false;

    if (/custom\s*colou?r/i.test(String(item.variant_title || ''))) return true;

    return Array.isArray(item.options_with_values) && item.options_with_values.some(function (option) {
      return /custom\s*colou?r/i.test(String(option && option.value || ''));
    });
  }

  function pickSelection(item) {
    var map = readMap();
    var entries = Object.entries(map).filter(function (pair) {
      var entry = pair[1];
      return entry && entry.color && (entry.finishType || entry.finish);
    });

    if (!entries.length) return null;

    var variant = normalize(item && (item.variant_title || item.title));

    var exact = entries.find(function (pair) {
      return normalize(pair[0]) === variant;
    });
    if (exact) return exact[1];

    var fuzzy = entries.find(function (pair) {
      var key = normalize(pair[0]);
      return key && variant && (variant.indexOf(key) !== -1 || key.indexOf(variant) !== -1);
    });
    if (fuzzy) return fuzzy[1];

    if (entries.length === 1) return entries[0][1];

    // Object insertion order keeps the latest selection at the end in the current helper.
    return entries[entries.length - 1][1];
  }

  function fetchCart() {
    return fetch(cartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function findTargetItem(cart, detail) {
    var items = (cart && cart.items) || [];
    var requestedKey = detail && detail.key ? String(detail.key) : '';

    if (requestedKey) {
      var byKey = items.find(function (item) { return String(item.key) === requestedKey; });
      if (byKey) return byKey;
    }

    var requestedVariantId = detail && (detail.variant_id || detail.variantId || detail.id);
    if (requestedVariantId) {
      var byVariant = items.slice().reverse().find(function (item) {
        return String(item.variant_id) === String(requestedVariantId) && isCustomColorLine(item);
      });
      if (byVariant) return byVariant;
    }

    return items.slice().reverse().find(isCustomColorLine) || null;
  }

  function sameProperties(item, selection) {
    var props = item && item.properties || {};
    return String(props['Color Code'] || '') === String(selection.color || '') &&
      String(props['Finish Type'] || '') === String(selection.finishType || selection.finish || '');
  }

  function updateLine(item, selection) {
    var properties = Object.assign({}, item.properties || {});
    properties['Color Code'] = String(selection.color || '').trim();
    properties['Finish Type'] = String(selection.finishType || selection.finish || '').trim();

    return fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: properties
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart line properties');
      return response.json();
    }).then(function (cart) {
      var updated = (cart.items || []).slice().reverse().find(function (candidate) {
        return String(candidate.variant_id) === String(item.variant_id) &&
          String((candidate.properties || {})['Color Code'] || '') === properties['Color Code'] &&
          String((candidate.properties || {})['Finish Type'] || '') === properties['Finish Type'];
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return updated ? updated.key : item.key;
    });
  }

  function enrich(detail) {
    return fetchCart().then(function (cart) {
      var item = findTargetItem(cart, detail || {});
      if (!item || !isCustomColorLine(item)) return detail && detail.key || '';

      var selection = pickSelection(item);
      if (!selection) return item.key;
      if (sameProperties(item, selection)) return item.key;

      return updateLine(item, selection);
    });
  }

  function enrichFromAngleEvent(detail) {
    // Serialize updates so double Angle events cannot race and create duplicated state.
    syncQueue = syncQueue.then(function () {
      return new Promise(function (resolve) { setTimeout(resolve, 80); });
    }).then(function () {
      return enrich(detail || {});
    }).catch(function (error) {
      console.warn('RK custom color property sync:', error);
      return detail && detail.key || '';
    });

    return syncQueue;
  }

  window.RKCustomColorLineProperties = {
    enrichFromAngleEvent: enrichFromAngleEvent
  };
})();
